import {create} from "zustand";

export const useModalStore = create((set) => ({
    // Модальное окно "информация о цене"
    priceInfoModalFlag: false,

    // Тип модального окна, которое открыть
    modalType: '',

    // Сумма всех платежей по рассрочкам для расчета графика в модалке (долями, плайт)
    installmentAmount: 0,

    // Скидка бонусами
    maxBonusesSubtract: 0,

    // Промокод для модалки с информацией
    promoCodeValue: '',

    // Модальное окно "узнать цену"
    findOutPriceModalState: {
        open: false,
        message: ''
    },

    // Модальное окно "Увеличение изображения"
    zoomImageModalState: {
        open: false,
        mediaIndex: 0
    },

    /**
     * Модальное окно "информация о цене"
     * @param modalType
     * @param installmentAmount
     * @param maxBonusesSubtract
     * @param promoCodeValue
     */
    openModalPriceInfo: (modalType = '', installmentAmount = 0, maxBonusesSubtract = 0, promoCodeValue = '') => set({
        modalType,
        installmentAmount,
        maxBonusesSubtract,
        promoCodeValue,
        priceInfoModalFlag: true,
    }),

    /**
     * Модальное окно "информация о цене"
     */
    closeModalPriceInfo: () => set({
        priceInfoModalFlag: false,
        modalType: '',
        installmentAmount: 0,
        maxBonusesSubtract: 0,
        promoCodeValue: '',
    }),

    /**
     * Модальное окно "узнать цену"
     * @param message
     */
    openModalFindOutPrice: (message) => set({
        findOutPriceModalState: {
            open: true,
            message
        }
    }),

    /**
     * Модальное окно "узнать цену"
     */
    closeModalFindOutPrice: () => set({
        findOutPriceModalState: {
            open: false,
            message: ''
        }
    }),

    /**
     * Модальное окно "Увеличение изображения"
     * @param mediaIndex
     */
    openZoomImageModal: (mediaIndex) => set({
        zoomImageModalState: {
            open: true,
            mediaIndex
        }
    }),

    /**
     * Модальное окно "Увеличение изображения"
     */
    closeZoomImageModal: () => set({
        zoomImageModalState: {
            open: false,
            mediaIndex: 0
        }
    }),
}));
